/**
 * @generated SignedSource<<ab6c1d36ec2424a925d98213474ea75f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UpdateCalendarEventInput = {
  calendarId: string;
  endAt: string;
  id: string;
  isAllDayEvent: boolean;
  startAt: string;
  title: string;
};
export type CalendarTeamEventEditScreenUpdateCalendarEventMutation$variables = {
  input: UpdateCalendarEventInput;
};
export type CalendarTeamEventEditScreenUpdateCalendarEventMutation$data = {
  readonly updateCalendarEvent: {
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"CalendarTeamEventItem_event" | "WidgetCalendarOverviewEventItem_event">;
  };
};
export type CalendarTeamEventEditScreenUpdateCalendarEventMutation = {
  response: CalendarTeamEventEditScreenUpdateCalendarEventMutation$data;
  variables: CalendarTeamEventEditScreenUpdateCalendarEventMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isoString",
    "storageKey": null
  },
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "style",
        "value": "DEFAULT"
      }
    ],
    "kind": "ScalarField",
    "name": "storeFormattedDate",
    "storageKey": "storeFormattedDate(style:\"DEFAULT\")"
  }
],
v4 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "style",
        "value": "WEEKDAY_AND_DATE"
      }
    ],
    "kind": "ScalarField",
    "name": "storeFormattedDate",
    "storageKey": "storeFormattedDate(style:\"WEEKDAY_AND_DATE\")"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CalendarTeamEventEditScreenUpdateCalendarEventMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CalendarEvent",
        "kind": "LinkedField",
        "name": "updateCalendarEvent",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "WidgetCalendarOverviewEventItem_event"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CalendarTeamEventItem_event"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CalendarTeamEventEditScreenUpdateCalendarEventMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CalendarEvent",
        "kind": "LinkedField",
        "name": "updateCalendarEvent",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "title",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "StoreCalendar",
            "kind": "LinkedField",
            "name": "storeCalendar",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "color",
                "storageKey": null
              },
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": "startAtDateAndTime",
            "args": null,
            "concreteType": "StoreZonedDate",
            "kind": "LinkedField",
            "name": "startAt",
            "plural": false,
            "selections": (v3/*: any*/),
            "storageKey": null
          },
          {
            "alias": "endAtDateAndTime",
            "args": null,
            "concreteType": "StoreZonedDate",
            "kind": "LinkedField",
            "name": "endAt",
            "plural": false,
            "selections": (v3/*: any*/),
            "storageKey": null
          },
          {
            "alias": "startAtWeekdayAndDate",
            "args": null,
            "concreteType": "StoreZonedDate",
            "kind": "LinkedField",
            "name": "startAt",
            "plural": false,
            "selections": (v4/*: any*/),
            "storageKey": null
          },
          {
            "alias": "endAtWeekdayAndDate",
            "args": null,
            "concreteType": "StoreZonedDate",
            "kind": "LinkedField",
            "name": "endAt",
            "plural": false,
            "selections": (v4/*: any*/),
            "storageKey": null
          },
          {
            "alias": "endAtTime",
            "args": null,
            "concreteType": "StoreZonedDate",
            "kind": "LinkedField",
            "name": "endAt",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "style",
                    "value": "TIME_ONLY"
                  }
                ],
                "kind": "ScalarField",
                "name": "storeFormattedDate",
                "storageKey": "storeFormattedDate(style:\"TIME_ONLY\")"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isAllDayEvent",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "7156f12cfa407aabb254936cd3585d26",
    "id": null,
    "metadata": {},
    "name": "CalendarTeamEventEditScreenUpdateCalendarEventMutation",
    "operationKind": "mutation",
    "text": "mutation CalendarTeamEventEditScreenUpdateCalendarEventMutation(\n  $input: UpdateCalendarEventInput!\n) {\n  updateCalendarEvent(input: $input) {\n    id\n    ...WidgetCalendarOverviewEventItem_event\n    ...CalendarTeamEventItem_event\n  }\n}\n\nfragment CalendarOverviewEventItemDateTime_event on CalendarEvent {\n  startAtDateAndTime: startAt {\n    isoString\n    ...StoreFormattedDate_2LP8ap\n  }\n  endAtDateAndTime: endAt {\n    isoString\n    ...StoreFormattedDate_2LP8ap\n  }\n  startAtWeekdayAndDate: startAt {\n    ...StoreFormattedDate_1hpjGt\n  }\n  endAtWeekdayAndDate: endAt {\n    ...StoreFormattedDate_1hpjGt\n  }\n  endAtTime: endAt {\n    ...StoreFormattedDate_1b2lNL\n  }\n  isAllDayEvent\n}\n\nfragment CalendarTeamEventItem_event on CalendarEvent {\n  title\n  storeCalendar {\n    color\n    id\n  }\n  ...CalendarOverviewEventItemDateTime_event\n}\n\nfragment StoreFormattedDate_1b2lNL on StoreZonedDate {\n  storeFormattedDate(style: TIME_ONLY)\n}\n\nfragment StoreFormattedDate_1hpjGt on StoreZonedDate {\n  storeFormattedDate(style: WEEKDAY_AND_DATE)\n}\n\nfragment StoreFormattedDate_2LP8ap on StoreZonedDate {\n  storeFormattedDate(style: DEFAULT)\n}\n\nfragment WidgetCalendarOverviewEventItem_event on CalendarEvent {\n  title\n  storeCalendar {\n    color\n    id\n  }\n  ...CalendarOverviewEventItemDateTime_event\n}\n"
  }
};
})();

(node as any).hash = "fca15b7287b007745448508c22c09dbd";

export default node;
